import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AddCommentIcon from "@mui/icons-material/AddComment";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import ArticleIcon from "@mui/icons-material/Article";
import BadgeIcon from "@mui/icons-material/Badge";
import BlockIcon from "@mui/icons-material/Block";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import ChatIcon from "@mui/icons-material/Chat";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import GroupIcon from "@mui/icons-material/Group";
import HailIcon from "@mui/icons-material/Hail";
import HandymanIcon from "@mui/icons-material/Handyman";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleIcon from "@mui/icons-material/People";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RememberMeIcon from "@mui/icons-material/RememberMe";
import SegmentIcon from "@mui/icons-material/Segment";
import SettingsIcon from "@mui/icons-material/Settings";
import ThreePIcon from "@mui/icons-material/ThreeP";
import TimelineIcon from "@mui/icons-material/Timeline";
import TodayIcon from "@mui/icons-material/Today";
import BookIcon from "@mui/icons-material/Book";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { RoutesMap } from "../../types";
import { routeAdminType } from "../../types/typeComponents/NavSection";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LanguageIcon from '@mui/icons-material/Language';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ImageIcon from '@mui/icons-material/Image';

export const icons = {
  AddCommentIcon,
  AddToQueueIcon,
  ArticleIcon,
  BadgeIcon,
  ChatIcon,
  ContentPasteIcon,
  DashboardIcon,
  EqualizerIcon,
  FormatListBulletedIcon,
  GroupIcon,
  HailIcon,
  HandymanIcon,
  PaidIcon,
  PeopleIcon,
  PeopleAltIcon,
  PermContactCalendarIcon,
  SegmentIcon,
  SettingsIcon,
  ThreePIcon,
  TimelineIcon,
  ManageAccountsIcon,
  AccountCircleIcon,
  NotificationsIcon,
  RememberMeIcon,
  CardMembershipIcon,
  TodayIcon,
  BlockIcon,
  ReceiptLongIcon,
  LanguageIcon,
  HandshakeIcon,
  ImageIcon,
};

const rutasAdmin: routeAdminType[] = [
  {
    id: 1,
    name: "Alumnos",
    location: RoutesMap.STUDENTS,
    icon: <AccountBoxIcon />,
  },
  {
    id: 2,
    name: "Programas",
    location: RoutesMap.PROGRAMS,
    icon: <AutoAwesomeMotionIcon />,
  },
  {
    id: 5,
    name: "Recompensas",
    icon: <BookIcon />,
    rutas: [
      {
        name_ruta: "Puntos por concepto",
        location: RoutesMap.REWARDS,
        icon: <EmojiEventsIcon />,
      },
      {
        name_ruta: "Puntos acumulados",
        location: RoutesMap.REWARDSTUDENT,
        icon: <FactCheckIcon />,
      },
    ],
  },
  {
    id: 3,
    name: "Cursos",
    icon: <BookIcon />,
    rutas: [
      {
        name_ruta: "Cursos",
        location: RoutesMap.COURSES,
        icon: <BookIcon />,
      },
      {
        name_ruta: "Ciclos",
        location: RoutesMap.CYCLE,
        icon: <FactCheckIcon />,
      },
      {
        name_ruta: "Certificados",
        location: RoutesMap.CERTIFICATES,
        icon: <CardMembershipIcon />,
      },
    ],
  },
  {
    id: 4,
    name: "Talleres",
    icon: <WorkspacesIcon />,
    rutas: [
      {
        name_ruta: "Talleres",
        location: RoutesMap.WORKSHOPS,
        icon: <WorkspacesIcon />,
      },
      {
        name_ruta: "Ciclos",
        location: RoutesMap.WORKSHOP_CYCLE,
        icon: <FactCheckIcon />,
      },
      {
        name_ruta: "Constancias",
        location: RoutesMap.WORKSHOP_DOCUMENTS,
        icon: <FileCopyIcon />,
      },
    ],
  },
  {
    id: 5,
    name: "Página Web",
    icon: <LanguageIcon />,
    rutas: [
      {
        name_ruta: "Portadas",
        location: RoutesMap.PAGE_BANNERS,
        icon: <ImageIcon />,
      },
      {
        name_ruta: "Cursos",
        location: RoutesMap.PAGE_COURSES,
        icon: <BookIcon />,
      },
      {
        name_ruta: "Docentes",
        location: RoutesMap.PAGE_TEACHERS,
        icon: <PeopleIcon />,
      },
      {
        name_ruta: "Alianzas",
        location: RoutesMap.PAGE_ALLIANCES,
        icon: <HandshakeIcon />,
      },
      {
        name_ruta: "Noticias",
        location: RoutesMap.PAGE_NOTICES,
        icon: <ArticleIcon />,
      },
      {
        name_ruta: "Pre Alumnos",
        location: RoutesMap.PAGE_PRE_STUDENTS,
        icon: <PeopleAltIcon />,
      }
    ],
  }
];

export const navSections = {
  Admin: rutasAdmin,
};
